<div class="containeer-fluid"></div>
<div class="row">
  <div class="col-auto g-0 d-flex align-items-start">
    <app-uiform-side-menu
      [uiformId]="uiformId"
      targetId="customChart"
      [usecaseId]="usecaseId"
    >
    </app-uiform-side-menu>
  </div>

  <div class="col-11" #content>
    <div class="col col-md-12">
      <h5><i class="fas fa-database"></i> {{ usecaseSchema["name"] }} Custom Chart
        <a
        href="javascript:void(0)"
      (click)="downloadPDF()"
        title="PDF"
        class="me-1"
      >
        <i class="fa fa-file-pdf"></i>
      </a>
      </h5>
    </div>
    <div class="container ">
      <app-dynamic-chart [attributes]="attributeList" [data]="uiformDataList" [collection_name]="usecaseSchema['collectionName']" />
   
    </div>
  </div>
</div>
